export class EeviAssertion extends Error {

}


export function assert(condition: any, msg?: string): asserts condition {
    if (!condition) {
        throw new EeviAssertion(msg);
    }
}